// 월드 좌표를 화면(CSS px)으로 투영하는 순수 계산(QA 겹침 측정용, three 의존 없음)
// 행렬은 three의 열 우선 16개 배열(Matrix4.elements) 그대로 받는다.

export interface Pt { x: number; y: number }
export interface Rect { x: number; y: number; w: number; h: number }

/** 월드 점 → 화면 px. 카메라 뒤(w<=0)면 null. viewInv는 matrixWorldInverse, proj는 projectionMatrix */
export function projectToScreen(p: readonly [number, number, number], viewInv: ArrayLike<number>, proj: ArrayLike<number>, width: number, height: number): Pt | null {
  const [x, y, z] = p;
  const vx = viewInv[0] * x + viewInv[4] * y + viewInv[8] * z + viewInv[12];
  const vy = viewInv[1] * x + viewInv[5] * y + viewInv[9] * z + viewInv[13];
  const vz = viewInv[2] * x + viewInv[6] * y + viewInv[10] * z + viewInv[14];
  const cx = proj[0] * vx + proj[4] * vy + proj[8] * vz + proj[12];
  const cy = proj[1] * vx + proj[5] * vy + proj[9] * vz + proj[13];
  const cw = proj[3] * vx + proj[7] * vy + proj[11] * vz + proj[15];
  if (!(cw > 1e-9)) return null;
  return { x: (cx / cw * 0.5 + 0.5) * width, y: (1 - (cy / cw * 0.5 + 0.5)) * height };
}

/** 점이 rect 안(경계 포함, margin만큼 부풀림)인지 */
export function pointInRect(p: Pt, r: Rect, margin = 0): boolean {
  return p.x >= r.x - margin && p.x <= r.x + r.w + margin && p.y >= r.y - margin && p.y <= r.y + r.h + margin;
}
